import React, { useState, useEffect } from "react";
import Popup from "../Popup";
import FormHeader from "../form/Header";
import { useTranslation } from "react-i18next";
import { CentsToDollars } from "../../utils/formatPrice";
import { formatDate } from "../../utils/formatDate";
import { GetReplaceOrder } from "../../api/sell-orders/getReplaceOrder";


const ViewReplaceOrder = ({ order, onClose, ...props }) => {
  const { t } = useTranslation();
  const [fullOrder, setFullOrder] = useState("");
  const [loading, setLoading] = useState(false);

  const getFullOrder = async () => {
    if (order.id) {
      setLoading(true);
      try {
        const { data } = await GetReplaceOrder({ id: order.id });
        setFullOrder(data);
      } catch (err) {
        console.log("Full order couldn't be fetched. " + err.message);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    getFullOrder();
    // eslint-disable-next-line
  }, []);

  return (
    <Popup size="large" withClose withOverlay onClose={onClose}>
      <FormHeader
        title={`${t("Replacement Order ID")}: ${order.id}`}
      ></FormHeader>

      <div className="mt-5">
        <p>
          {t("Order number")}: <strong>{order.id}</strong>
        </p>
        <p>
          {t("Order date")}: <strong>{formatDate(order.created_at)}</strong>
        </p>
        <p>
          {t("Type")}: <strong>{order.type}</strong>
        </p>
        <p>
          {t("Status")}:{" "}
          <strong className="text-uppercase">{order.status}</strong>
        </p>
        <p>
          {t("User")}: <strong>{order.created_by_name}</strong>
        </p>
        <p>
          {t("Total Replacement Amount")}:{" "}
          <strong>${CentsToDollars(order.amount_transfered || 0)}</strong>
        </p>
        {Number(order.total_service_fee || 0) > 0 && (
          <p>
            {t("Replacement Fee")}:{" "}
            <strong>${CentsToDollars(order.total_service_fee || 0)}</strong>
          </p>
        )}
        {Number(order.total_service_fee || 0) > 0 && (
          <p>
            {t("Net Amount")}:{" "}
            <strong>
              ${CentsToDollars(
                (order.amount_transfered || 0) -
                  (order.total_service_fee || 0)
              )}
            </strong>
          </p>
        )}
        <p>
          {t("Client Company Name")}:{" "}
          <strong>{order.client_company_name}</strong>
        </p>
        <p>
          {t("Office Name")}: <strong>{order.office_name}</strong>
        </p>
        <p>
          {t("Transaction ID")}: <strong>{order.transaction_id}</strong>
        </p>
        {loading && t("Loading additional data...")}
        {!loading && fullOrder && (
          <>
            <div className="mb-3">
              <h5 className="mb-1 mt-2">
                {t("Original and New Card Details")}:
              </h5>
              <table>
                <thead>
                  <tr>
                    <th>{t("Original proxy number")}</th>
                    <th>{t("Amount")}</th>
                    <th>{t("New proxy number")}</th>
                    <th>{t("Amount")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{fullOrder.old_start_processor_reference}</td>
                    <td>
                      {fullOrder.amount_transfered ? "-" : ""}
                      {CentsToDollars(fullOrder.amount_transfered || 0)}
                    </td>
                    <td>{fullOrder.new_processor_reference || "-"}</td>
                    <td>{CentsToDollars(fullOrder.amount_transfered || 0)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </Popup>
  );
};

export default ViewReplaceOrder;
